import { FormInstance } from 'antd';

export * from './MonthlyCardPanel';
export * from './MonthlyCardSetPanel';
export * from './PanelControl';
export * from './PanelTogglesControlMyAlarm';
export * from './ToggleList';
export * from './ToggleListMyAlarm';

export const isTrueOnFields = (form: FormInstance, fields: string[]): boolean => {
    let isSet = false;
    fields.forEach((field: string): void => {
        const value = form.getFieldValue(field);
        isSet = isSet || !!value;
    });
    return isSet;
};
